import React from 'react';
import { useTranslation } from 'react-i18next';
import { ControlBarButton } from '@m12s/component-library';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { UtilityMenu } from 'components/UtilityMenu';
import { ban } from 'lib/icons';

import Routes from 'lib/utils/routes';

import { getIsAPMEnabled } from 'lib/selectors/getIsAPMEnabled';
import { getIsLaborTicketEnabled } from 'lib/selectors/getIsLaborTicketEnabled';
import { getIsErpDriven } from 'lib/selectors/getIsErpDriven';
import { getMachine } from 'lib/selectors/getMachine';
import {
  ControlBarResponsive,
  MobileIcon,
  ResponsiveText,
  Scrollable,
} from './styled';
import { ActivitiesJobControlBar } from './ActivitiesJobControlBar';
import { APMControlBar } from './APMControlBar';
import { CategorizeDowntime } from './ERPJobControlBar/CategorizeDowntime';
import { AuthenticationControls } from './AuthenticationControls';

const DefaultJobControlBar = ({ setControlAction }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const machine = useSelector(getMachine);
  const laborTicketsEnabled = useSelector(getIsLaborTicketEnabled);
  const isErpDriven = useSelector(getIsErpDriven);

  const isAPMEnabled = useSelector(getIsAPMEnabled);

  const JobControlBar = isAPMEnabled ? APMControlBar : ActivitiesJobControlBar;

  return (
    <ControlBarResponsive id="job-control-bar">
      <UtilityMenu />
      <Scrollable>
        {isErpDriven ? (
          // When ERP job dispatch is enabled AND machine is in MES mode, show only categorize downtime
          <CategorizeDowntime
            history={history}
            machine={machine}
            text="categorize"
          />
        ) : (
          <>
            <JobControlBar setControlAction={setControlAction} />
            {!laborTicketsEnabled && (
              <ControlBarButton
                id="reject-parts"
                onClick={() => {
                  return history.push(
                    Routes.machineIdRejectPartsPath(machine.id)
                  );
                }}
              >
                <MobileIcon icon={ban} />
                <ResponsiveText
                  full={t('rejectParts|full')}
                  medium={t('rejectParts|medium')}
                  short={t('rejectParts|short')}
                />
              </ControlBarButton>
            )}
            <CategorizeDowntime
              history={history}
              machine={machine}
              text="categorize"
            />

            <AuthenticationControls />
          </>
        )}
      </Scrollable>
    </ControlBarResponsive>
  );
};

export { DefaultJobControlBar };
